/**
 * @desc VAT管理
 */

import request from "@/utils/request";

// VAT列表查询
export function vatInvoiceList(data) {
  return request({
    url: '/base/vatInvoice/dataGrid',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

// VAT 企业信息修改
export function vatInvoiceEdit(data) {
  return request({
    url: '/base/vatInvoice/edit',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

// VAT管理修改状态
export function vatInvoiceModifyStatus(data) {
  return request({
    url: '/base/vatInvoice/modifyStatus',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

// 发票上传记录列表查询
export function vatUploadRecordList(data) {
  return request({
    url: '/operation/vatUploadRecord/recordPage',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}

// 上传发票
export function uploadVat(data) {
  return request({
    url: '/operation/vatUploadRecord/upload',
    method: 'post',
    data
  }).then((res) => {
    return Promise.resolve(res);
  });
}
